import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=384e7542&scoped=true&style=position%3A%20relative%3B&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"
import style0 from "./_Form.vue?vue&type=style&index=0&id=384e7542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e7542",
  null
  
)

export default component.exports